import { gql } from 'graphql-request';

export const RESTORE_S3_OBJECTS_QUERY = gql`
  mutation RestoreS3Objects($data: [RestoreS3ObjectsData!]!) {
    restoreS3Objects(input: { data: $data }) {
      status
      errors {
        fullMessages
      }
    }
  }
`;
